import { render } from "./LandingCatalogo.vue?vue&type=template&id=e457cc8a&scoped=true"
import script from "./LandingCatalogo.vue?vue&type=script&lang=js"
export * from "./LandingCatalogo.vue?vue&type=script&lang=js"

import "./LandingCatalogo.vue?vue&type=style&index=0&id=e457cc8a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e457cc8a"]])

export default __exports__